module.exports = __webpack_public_path__ + "img/org-bj.8c0bfb20.png";